import { useQuery } from '@tanstack/react-query'
import { cartApiService } from 'api/services'
import { QUERY_KEY } from 'app/constants'
import { useTranslation } from 'react-i18next'
import { useUser } from './use-user'
import { useMemo } from 'react'
import { IUseCart } from 'api/types/cart'

export const useCart = (): IUseCart => {
  const { i18n } = useTranslation()
  const { user } = useUser()
  const userId = user ? user.id : null

  const { data, isFetching, status } = useQuery({
    queryKey: [QUERY_KEY.cart, { userId, language: i18n.language }],
    queryFn: () => cartApiService.getCart(),
    enabled: !!userId,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
  })

  return useMemo(() => {
    return {
      data: data
        ? {
            data: data.data,
            totalPrice: data.headers['x-total-price'] as number,
            totalAmount: data.headers['x-total-amount'] as number,
          }
        : {
            data: [],
            totalPrice: 0,
            totalAmount: 0,
          },
      isFetching,
      status,
    }
  }, [data, isFetching, status])
}
